import { Button, Flex } from '@chakra-ui/react'

import { useReportingI18n } from '../i18n'

export type ViewType = 'chart' | 'table'

interface ViewToggleProps {
  value: ViewType
  onChange: (value: ViewType) => void
}

const ViewToggle = ({ value, onChange }: ViewToggleProps) => {
  const { text } = useReportingI18n()

  return (
    <Flex
      bg="bg.default"
      borderRadius="md"
      border="1px solid"
      borderColor="border.default"
      p="3px"
      gap="2px"
    >
      <Button
        size="sm"
        variant={value === 'chart' ? 'solid' : 'ghost'}
        bg={value === 'chart' ? 'bg.muted' : 'transparent'}
        color="fg.muted"
        fontFamily="Inter"
        fontSize="12px"
        fontWeight="500"
        lineHeight="16px"
        borderRadius="sm"
        px="12px"
        _hover={{
          bg: value === 'chart' ? 'bg.muted' : 'bg.subtle',
        }}
        onClick={() => onChange('chart')}
      >
        {text('inboundAnswerRate.viewToggle.chart', 'Chart')}
      </Button>
      <Button
        size="sm"
        variant={value === 'table' ? 'solid' : 'ghost'}
        bg={value === 'table' ? 'bg.muted' : 'transparent'}
        color="fg.muted"
        fontFamily="Inter"
        fontSize="12px"
        fontWeight="500"
        lineHeight="16px"
        borderRadius="sm"
        px="12px"
        _hover={{
          bg: value === 'table' ? 'bg.muted' : 'bg.subtle',
        }}
        onClick={() => onChange('table')}
      >
        {text('inboundAnswerRate.viewToggle.table', 'Table')}
      </Button>
    </Flex>
  )
}

export default ViewToggle
